import { render, staticRenderFns } from "./MarketInteractRecord.vue?vue&type=template&id=92fc2ed6&scoped=true"
import script from "./MarketInteractRecord.vue?vue&type=script&lang=js"
export * from "./MarketInteractRecord.vue?vue&type=script&lang=js"
import style0 from "./MarketInteractRecord.vue?vue&type=style&index=0&id=92fc2ed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fc2ed6",
  null
  
)

export default component.exports